"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JCRWriter = void 0;
var KeyPair_1 = require("./KeyPair");
var TokenValidator_1 = __importDefault(require("./TokenValidator"));
var TokenFormat_1 = require("./TokenFormat");
var RSA_1 = __importDefault(require("./RSA"));
var debug_1 = __importDefault(require("./debug"));
var debug = debug_1.default.extend('jcr');
var reader_debug = debug.extend('reader');
var writer_debug = debug.extend('writer');
var JCRWriter = /** @class */ (function () {
    function JCRWriter(pub, sub, etc, exp, ecs) {
        if (etc === void 0) { etc = null; }
        if (exp === void 0) { exp = null; }
        if (ecs === void 0) { ecs = undefined; }
        if (!sub) {
            throw new Error('Cannot instanciate JCRWriter without a valid sub');
        }
        this.pub = pub;
        this.sub = sub;
        this.etc = etc;
        this.exp = exp;
        this.ecs = ecs;
    }
    /**
     * Returns a signed JCR
     * @param prv Private key to use that matches the public key provided in the
     * constructor
     */
    JCRWriter.prototype.sign = function (prv, lightweight, compressed) {
        if (lightweight === void 0) { lightweight = false; }
        if (compressed === void 0) { compressed = false; }
        return __awaiter(this, void 0, void 0, function () {
            var headers, payload, unsigned_token, signature, jcr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        writer_debug({
                            action: 'sign-prep',
                            prv: prv,
                            this: {
                                pub: this.pub,
                                sub: this.sub,
                                etc: this.etc,
                                exp: this.exp,
                                ecs: this.ecs,
                            },
                        });
                        if (prv.keyid !== this.pub.keyid) {
                            throw new Error("Private key doesn't match public key");
                        }
                        headers = {
                            typ: 'JCR',
                            kid: this.pub.keyid,
                            alg: 'RS256',
                        };
                        payload = {
                            kid: this.pub.keyid,
                            sub: this.sub,
                        };
                        if (this.etc) {
                            payload.etc = this.etc;
                        }
                        if (this.exp) {
                            payload.exp = this.exp;
                        }
                        if (this.ecs) {
                            payload.ecs = this.ecs;
                        }
                        if (lightweight) {
                            payload.lightweight = lightweight;
                        }
                        if (compressed) {
                            payload.compressed = compressed;
                        }
                        unsigned_token = [TokenFormat_1.encode(headers), TokenFormat_1.encode(payload), KeyPair_1.stripPEMExtra(this.pub.data)].join('.');
                        writer_debug({
                            action: 'sign-sign',
                            prv: prv,
                            unsigned_token: unsigned_token,
                        });
                        return [4 /*yield*/, RSA_1.default.sign(prv, unsigned_token)];
                    case 1:
                        signature = _a.sent();
                        jcr = unsigned_token + '.' + signature;
                        writer_debug({
                            action: 'sign-verify',
                            unsigned_token: unsigned_token,
                            signature: signature,
                            pub: this.pub,
                        });
                        return [4 /*yield*/, RSA_1.default.verify(this.pub, unsigned_token, signature)];
                    case 2:
                        // validate signature matches
                        if (!(_a.sent())) {
                            throw new Error('Cannot confirm signature generated from private key with public key');
                        }
                        writer_debug({
                            action: 'sign-return',
                            jcr: jcr,
                        });
                        return [2 /*return*/, jcr];
                }
            });
        });
    };
    JCRWriter.fromKeyPair = function (pair, sub, etc, exp, ecs, lightWeight, compressed) {
        if (etc === void 0) { etc = null; }
        if (exp === void 0) { exp = null; }
        if (ecs === void 0) { ecs = undefined; }
        if (lightWeight === void 0) { lightWeight = false; }
        if (compressed === void 0) { compressed = false; }
        return __awaiter(this, void 0, void 0, function () {
            var jcr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jcr = new JCRWriter(pair.pub, sub, etc, exp, ecs);
                        return [4 /*yield*/, jcr.sign(pair.prv, lightWeight, compressed)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return JCRWriter;
}());
exports.JCRWriter = JCRWriter;
var JCR = /** @class */ (function () {
    function JCR(raw) {
        reader_debug({ action: 'constructor', raw: raw });
        this.validator = new TokenValidator_1.default(raw, 4, 'JCR');
        this.body = this.validator.at_decoded(1);
        if (this.body.kid !== this.validator.header.kid) {
            throw new Error("Invalid JCR, header kid doesn't match body kid");
        }
        this.pub = {
            keyid: this.validator.header.kid,
            data: KeyPair_1.addPEMExtra(this.validator.at(2), 'PUBLIC KEY'),
        };
        reader_debug({ action: 'constructed', this: { pub: this.pub, body: this.body } });
    }
    JCR.prototype.verify = function (now) {
        if (now === void 0) { now = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validator.verify(this.pub, { now: now })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JCR.prototype.verify_signature = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reader_debug({ action: 'verify' });
                        return [4 /*yield*/, this.validator.signature_matches(this.pub)];
                    case 1:
                        if (!(_a.sent())) {
                            throw new Error("Invalid request, signature doesn't match included public key");
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Object.defineProperty(JCR.prototype, "sub", {
        get: function () {
            return this.body.sub;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCR.prototype, "etc", {
        get: function () {
            return typeof this.body.etc !== 'undefined' ? this.body.etc : null;
        },
        enumerable: false,
        configurable: true
    });
    return JCR;
}());
exports.default = JCR;
